import { Button, TableCell } from '@ketch-com/deck'
import { useNavigate } from 'react-router-dom'

export const AuditLogRightViewRequestCell = ({ route }: { route: string }) => {
  const navigate = useNavigate()
  return (
    <TableCell>
      <Button color="tertiary" onClick={() => navigate(route)}>
        View
      </Button>
    </TableCell>
  )
}
